export const GET_ICEPACKS = 'icepacks/GET_ICEPACKS';
export const getIcepacksAction = payload => ({
	type: GET_ICEPACKS,
	payload,
});

export const SET_ICEPACKS = 'icepacks/SET_ICEPACKS';
export const setIcepacksAction = payload => ({
	type: SET_ICEPACKS,
	payload,
});

export const SET_IS_ICEPACKS_LOADING = 'icepacks/SET_IS_ICEPACKS_LOADING';
export const setIsIcepacksLoadingAction = payload => ({
	type: SET_IS_ICEPACKS_LOADING,
	payload,
});

export const SET_PAGINATION = 'icepacks/SET_PAGINATION';
export const setPaginationAction = payload => ({
	type: SET_PAGINATION,
	payload,
});

export const RESET_STATE = 'icepacks/RESET_STATE';
export const resetStateAction = () => ({
	type: RESET_STATE,
});
